import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DashboardLayout from "@/components/DashboardLayout";
import api from "@/lib/api";

const STATUSES = ["All", "Submitted", "Under Review", "In Planning", "Awaiting Client Confirmation", "Confirmed", "In Progress", "Completed", "Cancelled"];
const STATUS_PILL = {
  Submitted: "as-pill-blue", "Under Review": "as-pill-blue",
  "In Planning": "as-pill-orange", "Awaiting Client Confirmation": "as-pill-orange",
  Confirmed: "as-pill-gold", "In Progress": "as-pill-gold",
  Completed: "as-pill-green", Cancelled: "as-pill-red", Draft: "as-pill-muted",
};

export default function OpsTrips() {
  const [trips, setTrips] = useState([]);
  const [filter, setFilter] = useState("All");
  const [q, setQ] = useState("");

  useEffect(() => {
    const params = filter === "All" ? {} : { status: filter };
    api.get("/trips", { params }).then(r => setTrips(r.data));
  }, [filter]);

  const list = trips.filter(t => !q || (t.client_name || "").toLowerCase().includes(q.toLowerCase()) || t.legs?.[0]?.departure_airport?.includes(q.toUpperCase()) || t.legs?.[0]?.arrival_airport?.includes(q.toUpperCase()));

  return (
    <DashboardLayout role="ops">
      <div className="max-w-[1500px] mx-auto px-8 py-10">
        <div className="flex items-end justify-between mb-8">
          <div>
            <div className="as-overline">Missions</div>
            <h1 className="as-serif text-5xl font-light mt-2" data-testid="ops-trips-title">All Trips</h1>
          </div>
          <input value={q} onChange={e => setQ(e.target.value)} placeholder="Search by client or airport…" className="bg-[#FAF7F0] border border-[#E5DFD2] focus:border-[#A47E2A] focus:outline-none px-4 py-2 rounded-sm text-sm w-72" data-testid="ops-trips-search"/>
        </div>

        <div className="flex flex-wrap gap-2 mb-6">
          {STATUSES.map(s => (
            <button key={s} onClick={() => setFilter(s)} className={`as-mono text-[10px] uppercase tracking-[0.2em] px-4 py-2 rounded-sm border transition-all ${filter === s ? "border-[#A47E2A] text-[#A47E2A] bg-[#A47E2A]/5" : "border-[#E5DFD2] text-[#756E64] hover:text-[#1A1D24]"}`} data-testid={`ops-filter-${s.toLowerCase().replace(/\s+/g,'-')}`}>{s}</button>
          ))}
        </div>

        <div className="as-card overflow-hidden">
          <table className="w-full">
            <thead>
              <tr className="as-mono text-[10px] uppercase tracking-widest text-[#756E64] text-left">
                <th className="px-6 py-3">Route</th>
                <th className="px-6 py-3">Client</th>
                <th className="px-6 py-3">Type</th>
                <th className="px-6 py-3">Pax</th>
                <th className="px-6 py-3">Aircraft</th>
                <th className="px-6 py-3">Owner</th>
                <th className="px-6 py-3">Status</th>
              </tr>
            </thead>
            <tbody data-testid="ops-trips-tbody">
              {list.length === 0 && <tr><td colSpan="7" className="p-10 text-center text-[#756E64]">No trips.</td></tr>}
              {list.map(t => (
                <tr key={t.id} className="border-t border-[#E5DFD2] hover:bg-white transition-colors">
                  <td className="px-6 py-4">
                    <Link to={`/ops/trips/${t.id}`} className="as-serif text-lg hover:as-gold" data-testid={`ops-trip-${t.id}`}>
                      {t.legs?.[0]?.departure_airport} <span className="as-gold">→</span> {t.legs?.[0]?.arrival_airport}
                    </Link>
                    <div className="as-mono text-[10px] text-[#756E64] mt-1">{new Date(t.legs?.[0]?.departure_datetime).toUTCString().slice(5,22)}</div>
                  </td>
                  <td className="px-6 py-4 text-sm">{t.client_name}</td>
                  <td className="px-6 py-4 text-sm text-[#756E64]">{t.trip_type}</td>
                  <td className="px-6 py-4 text-sm">{t.passenger_count}</td>
                  <td className="px-6 py-4 text-sm as-mono">{t.aircraft_tail || t.aircraft_preference || "—"}</td>
                  <td className="px-6 py-4 text-sm">{t.owner_name || "—"}</td>
                  <td className="px-6 py-4"><div className={`as-pill ${STATUS_PILL[t.status]} inline-block`}>{t.status}</div></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </DashboardLayout>
  );
}
